<template>
  <div class="modal fade" id="signupModal" tabindex="-1" aria-labelledby="signupModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <button type="button" class="close position-absolute" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="row no-gutters">
          <!-- 左侧品牌区域 -->
          <div class="col-md-6 brand-section">
            <div class="brand-content">
              <img src="../assets/images/logo_da.png" alt="Logo" class="brand-logo">
              <div class="welcome-text-container">
                <h2>Welcome!</h2>
                <p class="welcome-text">Join our community and start your learning journey today.</p>
              </div>
              <div class="login-hint">
                Have an account? 
                <a href="#" @click.prevent="openLoginModal">Log in Now</a>
              </div>
            </div>
          </div>
          
          <!-- 右侧表单区域 -->
          <div class="col-md-6 form-section">
            <div class="form-content px-5 py-4">
              <h5 class="text-center mb-4">Register with your phone number</h5>
              <form @submit.prevent="handleSubmit">
                <div class="form-group">
                  <label>USERNAME (*)</label>
                  <input 
                    type="text" 
                    class="form-control" 
                    v-model="formData.username"
                    @blur="validateUsername"
                    :class="{'is-invalid': usernameError}"
                    placeholder="Username"
                  >
                  <div class="invalid-feedback">{{ usernameError }}</div>
                </div>
                
                <div class="form-group">
                  <label>PHONE NUMBER (*)</label>
                  <div class="input-group">
                    <input 
                      type="text" 
                      class="form-control" 
                      v-model="formData.phone"
                      placeholder="Phone Number"
                    >
                    <div class="input-group-append">
                      <button 
                        class="btn btn-outline-dark" 
                        type="button" 
                        @click="sendVerificationCode"
                        :disabled="!isPhoneValid || codeSent"
                      >
                        {{ codeSent ? `${countdown}s` : 'Send Code' }}
                      </button>
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <label>VERIFICATION CODE (*)</label>
                  <div class="verification-code-container">
                    <input 
                      v-for="(digit, index) in 6" 
                      :key="index"
                      type="text"
                      class="verification-code-input"
                      maxlength="1"
                      v-model="verificationDigits[index]"
                      @input="handleVerificationInput($event, index)"
                      @keydown.delete="handleBackspace($event, index)"
                      @keydown="preventNonNumeric"
                    >
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>PASSWORD (*)</label>
                      <input 
                        type="password" 
                        class="form-control" 
                        v-model="formData.password"
                        placeholder="Password"
                      >
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>REPEAT PASSWORD (*)</label>
                      <input 
                        type="password" 
                        class="form-control" 
                        v-model="formData.repeatPassword"
                        placeholder="Repeat Password"
                        :class="{'is-invalid': passwordError}"
                      >
                      <div class="invalid-feedback">{{ passwordError }}</div>
                    </div>
                  </div>
                </div>

                <div class="form-group form-check">
                  <input 
                    type="checkbox" 
                    class="form-check-input" 
                    id="agreement" 
                    v-model="formData.agreementAccepted"
                  >
                  <label class="form-check-label small" for="agreement">
                    I have read and accept the Terms and Conditions
                  </label>
                </div>

                <button 
                  type="submit" 
                  class="btn btn-dark btn-block py-2 mt-4"
                  :disabled="!isFormValid"
                >
                  Create Account
                </button>

                <div class="text-center mt-4">
                  <button type="button" class="btn btn-success btn-block">
                    <i class="fab fa-weixin mr-2"></i>Log in with WeChat
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SignUpModal',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: {
        username: '',
        phone: '',
        password: '',
        repeatPassword: '',
        agreementAccepted: false
      },
      verificationDigits: Array(6).fill(''),
      usernameError: '',
      passwordError: '',
      codeSent: false,
      countdown: 60,
      countdownTimer: null
    }
  },
  computed: {
    isPhoneValid() {
      return /^1[3-9]\d{9}$/.test(this.formData.phone)
    },
    verificationCode() {
      return this.verificationDigits.join('')
    },
    isFormValid() {
      return this.formData.username && 
             this.formData.phone && 
             this.verificationCode.length === 6 &&
             this.formData.password && 
             this.formData.repeatPassword &&
             !this.passwordError &&
             !this.usernameError &&
             this.formData.agreementAccepted
    }
  },
  watch: {
    'formData.password'() {
      this.validatePasswords()
    },
    'formData.repeatPassword'() {
      this.validatePasswords()
    }
  },
  mounted() {
    // document.body.style.overflow = 'hidden'
    this.$root.$on('open-signup', () => {
      $('#signupModal').modal('show')
    })
  },
  beforeDestroy() {
    // document.body.style.overflow = ''
    this.$root.$off('open-signup')
  },
  methods: {
    validatePasswords() {
      if (this.formData.password && this.formData.repeatPassword) {
        if (this.formData.password !== this.formData.repeatPassword) {
          this.passwordError = '两次输入的密码不一致'
        } else {
          this.passwordError = ''
        }
      }
    },
    handleVerificationInput(event, index) {
      const input = event.target.value
      if (input && /^\d$/.test(input)) {
        this.verificationDigits[index] = input
        if (index < 5) {
          this.$nextTick(() => {
            const nextInput = event.target.parentElement.children[index + 1]
            nextInput.focus()
          })
        }
      } else {
        this.verificationDigits[index] = ''
      }
    },
    handleBackspace(event, index) {
      if (event.key === 'Backspace' && !this.verificationDigits[index]) {
        if (index > 0) {
          this.$nextTick(() => {
            const prevInput = event.target.parentElement.children[index - 1]
            prevInput.focus()
          })
        }
      }
    },
    preventNonNumeric(event) {
      if (!/^\d$/.test(event.key) && !['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight'].includes(event.key)) {
        event.preventDefault()
      }
    },
    async validateUsername() {
      if (!this.formData.username) {
        this.usernameError = '用户名不能为空'
        return
      }

      // 验证用户名格式
      const usernameRegex = /^(?![0-9]+$)(?![\-\_]+$)[a-zA-Z0-9\-\_]{1,20}$/
      if (!usernameRegex.test(this.formData.username)) {
        this.usernameError = '用户名格式不正确（1-20位字母、数字或者下划线和横线组成，不能是纯数字和纯符号）'
        return
      }

      try {
        // 这里需要调用后端API进行验证
        const response = await fetch('/api/auth/validate-username', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ username: this.formData.username })
        })
        const result = await response.json(); // 修改变量名为 result
        
        // 根据新的数据结构调整判断逻辑
        if (response.ok && result.code === 200) {
          if (!result.data.available) { // 假设后端返回 data: { available: boolean }
            this.usernameError = '该用户名已被注册'
          } else {
            this.usernameError = ''
          }
        } else {
          this.usernameError = result.message || '验证用户名失败，请稍后重试';
        }
      } catch (error) {
        console.error('验证用户名时出错：', error)
        this.usernameError = '验证用户名时出错，请稍后重试'
      }
    },

    async sendVerificationCode() {
      try {
        // 这里需要调用后端API发送验证码
        const response = await fetch('/api/auth/send-verification-code', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ phone: this.formData.phone })
        })
        
        const result = await response.json(); // 修改变量名为 result

        // 根据新的数据结构调整判断逻辑
        if (response.ok && result.code === 200) {
          this.codeSent = true
          this.startCountdown()
        } else {
          // 可以根据后端返回的 message 显示更具体的错误信息
          this.showToast('error', result.message || '发送验证码失败，请稍后重试');
        }
      } catch (error) {
        console.error('发送验证码时出错：', error)
      }
    },

    startCountdown() {
      this.countdown = 60
      this.countdownTimer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--
        } else {
          this.codeSent = false
          clearInterval(this.countdownTimer)
        }
      }, 1000)
    },

    async handleSubmit() {
      if (!this.isFormValid) {
        this.showToast('error', '请填写完整表单');
        return;
      }
      this.isLoading = true;
      // Add verificationCode to formData directly
      this.formData.verificationCode = this.verificationCode;

      try {
        const response = await fetch('/api/auth/register', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(this.formData)
        });
        
        if (response.ok) {
          const responseJson = await response.json();
          // console.log('注册响应：', responseJson);
          if (responseJson.code == 200) {
            // 保存用户信息到本地存储
            localStorage.setItem('userInfo', JSON.stringify(responseJson.data.user));
            localStorage.setItem('token', responseJson.data.token);
            // 更新父组件的用户状态
            this.$parent.currentUser = responseJson.data.user;
            this.showToast('success', '注册成功');
            $('#signupModal').modal('hide');
          } else {
            this.showToast('error', data.message || '注册失败');
          }
        } else {
          const data = await response.json();
          this.showToast('error', data.message || '注册失败');
        }
      } catch (error) {
        console.error('注册时出错：', error);
        this.showToast('error', '网络错误，请稍后再试');
      }
    },
    showToast(type, message) {
      if (type === 'success') {
        this.$toast.success(message);
      } else if (type === 'error') {
        this.$toast.error(message);
      }
    },
    openLoginModal() {
      $('#signupModal').modal('hide');  // 关闭当前注册模态框
      this.$nextTick(() => {
        this.$root.$emit('open-login')  // 触发打开登录模态框的事件
      })
    }
  }
}
</script>

<style scoped>
.modal-dialog {
  max-width: 900px;
}

.modal-content {
  border-radius: 8px;
  border: none;
  overflow: hidden;
  position: relative;
}

.close {
  right: 1rem;
  top: 1rem;
  z-index: 1050;
}

.brand-section {
  background-color: #f8f9fa;
  padding: 3rem 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  min-height: 600px;  /* 确保最小高度 */
}

.brand-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 2rem 0;
}

.brand-logo {
  max-width: 120px;
  height: auto;
  margin-bottom: 2rem;
}

.welcome-text-container {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 4rem 0;
}

.welcome-text-container h2 {
  font-size: 2.5rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
  color: #333;
}

.welcome-text {
  font-size: 1.2rem;
  color: #666;
  line-height: 1.6;
  max-width: 80%;
  margin: 0 auto;
}

.welcome-image {
  max-width: 80%;
  height: auto;
  margin: 2rem 0;
}

.login-hint {
  margin-top: auto;
  color: #666;
}

.login-hint a {
  color: #333;
  font-weight: 600;
  text-decoration: none;
}

.login-hint a:hover {
  text-decoration: underline;
}

.form-section {
  background-color: #fff;
}

.form-content {
  max-height: 80vh;
  overflow-y: auto;
}

@media (max-width: 768px) {
  .modal-dialog {
    margin: 0.5rem;
  }
  
  .brand-section {
    display: none;
  }
  
  .form-content {
    padding: 1rem !important;
  }
}

.modal-header {
  padding: 2rem 1rem 1rem;
}

.modal-title {
  font-size: 1.8rem;
  font-weight: 600;
}

.form-group label {
  font-size: 0.8rem;
  font-weight: 600;
  color: #666;
  margin-bottom: 0.5rem;
}

.form-control {
  border-radius: 4px;
  padding: 0.75rem 1rem;
  border: 1px solid #ddd;
}

.verification-code-container {
  display: flex;
  gap: 10px;
  justify-content: space-between;
}

.verification-code-input {
  width: calc(16.666% - 8px);
  height: 45px;
  text-align: center;
  font-size: 1.2rem;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.verification-code-input:focus {
  border-color: #333;
  outline: none;
}

.btn-outline-dark {
  min-width: 100px;
}

.social-buttons {
  display: flex;
  justify-content: center;
  gap: 1rem;
}

.social-buttons .btn {
  width: 40px;
  height: 40px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

@media (max-width: 576px) {
  .modal-dialog {
    margin: 1rem;
  }
  
  .modal-body {
    padding: 1rem !important;
  }
  
  .verification-code-input {
    height: 40px;
    font-size: 1rem;
  }
}

.btn-success {
  background-color: #07C160;
  border-color: #07C160;
}

.btn-success:hover {
  background-color: #06AD56;
  border-color: #06AD56;
}
</style>